export const Seo = ({ page }) => {
  if (!page) return null;
  const m = page.meta;
  return (
    <>
      <title>{m.title}</title>
      <meta name="description" content={m.description || ""} />
      <meta name="robots" content={m.robots} />
      <link rel="canonical" href={m.canonical} />
      {Object.entries(m.alternates || {}).map(([l, u]) => <link key={l} rel="alternate" hrefLang={l} href={u} />)}
      {m.alternates?.de && <link rel="alternate" hrefLang="x-default" href={m.alternates.de} />}
      <meta property="og:title" content={m.title} />
      <meta property="og:description" content={m.description || ""} />
      <meta property="og:url" content={m.canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="TennisTipps" />
      {page.jsonld?.map((j, i) => <script key={i} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(j) }} />)}
    </>
  );
};

export const NoIndex = ({ title }) => (<><title>{`${title} | TennisTipps`}</title><meta name="robots" content="noindex,nofollow" /></>);
